// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  apiPath: 'http://localhost:7071/api',
  auth: {
    userPoolId: 'eu-central-1_mWi1SGlQi',
    clientId: '2hh1adgd9dt5om6igt3rlq9lrp',
    providerName: 'aad',
    domainName: 'https://aut-recommendationdevelop.auth.eu-central-1.amazoncognito.com',
    routeBase: '',
    redirectUrl: 'http://localhost:4200'
  },
  cognitoAllowUserPassLogin: true,
  cognitoAllowOAuthLogin: true,
  federatedLoginLabel: 'Single Sign On',
  region: 'eu-central-1'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
